import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from '../../services/app.service';
import { ToastrService } from 'ngx-toastr';
import { FormatFieldName } from 'src/app/content/pages/campagne/fomatFieldName';

@Component({
    selector: 'app-historiques',
    templateUrl: 'historiques.component.html',
    styles: [`
        ::placeholder {
            color: #000;
        }
    `]
})

export class HistoriquesComponent implements OnInit {
    @Input() tableFields: any[];
    @Input() rowData: any;
    @Input() vue: 'CréationOREvenement' | 'Mise à jour';
    @Input() listeOfKeys: any[];
    newTab: { [key: string]: string | boolean }[] = [];
    // fieldName : any

    @Output() tabChange = new EventEmitter<any>();
    public response: any;
    public p = 1;
    public listHistorique: any = [];
    constructor(
        public activeModal: NgbActiveModal,
        public loadingBar: LoadingBarService,
        public _service: AppService,
        public toastrService: ToastrService,
        public fieldName: FormatFieldName
    ) { }

    public ngOnInit(): void {
        //  this.getHistorique(); 
        this.listeOfKeys?.map(value => {
            if (this.vue == 'Mise à jour') {
              value?.map(e => {
                const champs = this.fieldName?.formatFieldName(e)
                this.newTab.push({
                  'champs': champs,
                  'valeurPrecedentes': this.rowData[0]?.after[e] ?? 'N/A',
                  'valeursActuelles': this.rowData[0]?.before[e] ?? 'N/A',
                  isIdentique: this.rowData[0]?.before[e] == this.rowData[0]?.after[e]
                })
              })
            } else if(this.vue == 'CréationOREvenement') {
              // begin: tbody création
              value?.map(e => {
                const champs = this.fieldName?.formatFieldName(e)
                this.newTab.push({
                  'champs': champs,
                  'valeursActuelles': this.rowData[0]?.[e] ?? ''
                })
              })
            }
          })
    }

    public async getHistorique(): Promise<void> {
        const data = {
            sous_module: this.rowData?.sous_module,
            modele_id: this.rowData?.id
        };
        this.loadingBar.start();
        try {
            const res = await this._service.postData(`log/users-activites?page=${this.p}`, data).toPromise();
            this.response = res['data'];
            this.listHistorique = this.response['data'];
            this.listHistorique.forEach(element => { element.nom_prenoms = '[' + element?.user?.nom + ' ' + element?.user?.prenoms + '] ' + element?.ip });
        } catch (error) {
            this.toastrService.error(error.error.message);
        } finally {
            this.loadingBar.stop();
        }
    }

    public onPageChange(event) {
        this.p = event;
        this.getHistorique()
    }

}
